<template>
    <kimsa-text-field
        class="phone-field"
        :label="label"
        :placeholder="placeholder"
        :value="value"
        inputMode="tel"
        @change="$emit('change', $event)"
    >
        <template #prepend-inner>
            <v-select
                class="phone-code-select"
                color="secondary"
                item-color="secondary"
                :items="countries"
                :value="code"
                item-value="phoneCode"
                item-text="phoneCode"
                placeholder="+--"
                append-icon="mdi-chevron-down"
                :menu-props="menuProps"
                hide-details dense flat
                @change="$emit('change:code', $event)"
            >
                <template #selection>
                    <span class="phone-code-value">{{ code }}</span>
                </template>
                <template #item="{ item, on, attrs }">
                    <v-list-item v-on="on" v-bind="attrs" class="dot-item">
                        <span class="sel-dot" :class="{ 'sel-dot--active': code === item.phoneCode }"></span>
                        <span class="sel-name" :class="{ 'sel-name--active': code === item.phoneCode }">{{ countryLabel(item.name) }}</span>
                        <v-spacer/>
                        <span class="phone-code-list-code">{{ item.phoneCode }}</span>
                    </v-list-item>
                </template>
            </v-select>
        </template>
    </kimsa-text-field>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { mapState } from 'vuex'

export default {
    name: "KimsaPhoneField",
    components: { KimsaTextField },
    props: {
        value: { type: [String, Number], default: '' },
        code: { type: String, default: '' },
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
    },
    computed: {
        ...mapState(['countries']),
        menuProps() {
            return { offsetY: true, nudgeBottom: 8, maxHeight: 320, contentClass: 'kimsa-select-menu phone-code-menu' }
        },
    },
}
</script>

<style scoped>
.phone-field ::v-deep .v-input__prepend-inner {
    align-self: stretch;
    display: flex;
    align-items: stretch;
    margin: 0;
    padding: 0;
}

.phone-code-select {
    flex: 0 0 auto;
    width: 84px;
    margin-right: 10px;
    border-right: 1px solid var(--v-outline-base);
    cursor: pointer;
}

.phone-code-select ::v-deep .v-input__control,
.phone-code-select ::v-deep .v-input__slot,
.phone-code-select ::v-deep .v-select__slot {
    height: 100%;
    min-height: 0 !important;
    align-items: center;
}

.phone-code-select ::v-deep .v-input__slot {
    margin: 0;
    padding: 0 8px 0 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    cursor: pointer;
}

.phone-code-select ::v-deep .v-input__slot::before,
.phone-code-select ::v-deep .v-input__slot::after {
    display: none !important;
}

.phone-code-select ::v-deep .v-select__selections {
    flex-wrap: nowrap;
    padding: 0 !important;
    min-height: 0 !important;
    align-items: center;
    line-height: 1;
}

.phone-code-select ::v-deep .v-select__selections input {
    padding: 0;
}

.phone-code-select ::v-deep .v-input__append-inner {
    margin: 0;
    padding: 0;
    align-self: center;
}

.phone-code-select ::v-deep .v-input__append-inner .v-icon {
    font-size: 20px;
}

.phone-code-value {
    font-size: 14px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
}

.phone-code-list-code {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-accent-base);
    margin-left: 16px;
}
</style>

<style>
.phone-code-menu {
    min-width: 260px !important;
}
</style>
